/**
 * Player: fixed Y, world scrolls; analog left/right; no lane snap.
 */
import * as C from "../../config/constants.js";

const DEFAULT_RUN_CONFIG = C.RUN_CONFIG || {};

function nowMs() {
  return typeof performance !== "undefined" ? performance.now() : Date.now();
}

function easeOutCubic(t) {
  var u = 1 - Math.max(0, Math.min(1, t));
  return 1 - u * u * u;
}

export class RunPlayer {
  constructor(x, y, scale, runConfig) {
    this.runConfig = runConfig || DEFAULT_RUN_CONFIG;
    this.x = x;
    this.y = y;
    this.maxHp = 3;
    this.minHp = 0;
    this.baseHp = this.maxHp;
    this.hp = this.maxHp;
    this.visualRadius = (scale && scale.playerVisualRadius) ? scale.playerVisualRadius : 25;
    this.hasShield = false;
    /** @type {{kind: 'in'|'out', t0: number}|null} */
    this.shieldFx = null;
  }
  draw(ctx) {
    ctx.save();
    ctx.fillStyle = "#ffffff";
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.visualRadius, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = "rgba(100, 200, 255, 0.3)";
    ctx.beginPath();
    ctx.arc(
      this.x - this.visualRadius * 0.3,
      this.y - this.visualRadius * 0.3,
      this.visualRadius * 0.4,
      0,
      Math.PI * 2
    );
    ctx.fill();
    ctx.restore();
  }
  applyHazardDamage(currentTime) {
    if (this.hasShield) {
      this.hasShield = false;
      this._startShieldFx("out", currentTime);
    } else {
      this.hp = Math.max(this.minHp, this.hp - 1);
    }
  }
  /** Shield lasts until Fall stage ends or a boulder breaks it. */
  activateShield(currentTime) {
    this.hasShield = true;
    this._startShieldFx("in", currentTime);
  }
  _startShieldFx(kind, currentTime) {
    var t0 = currentTime != null && isFinite(currentTime) ? currentTime : nowMs();
    this.shieldFx = { kind: kind, t0: t0 };
  }
  /**
   * Visual state for the flask shield field.
   * @returns {{alpha: number, scale: number}|null}
   */
  getShieldVisual(currentTime) {
    var cfg = this.runConfig || {};
    var appearMs = cfg.SHIELD_APPEAR_MS != null ? Number(cfg.SHIELD_APPEAR_MS) : 280;
    var disappearMs = cfg.SHIELD_DISAPPEAR_MS != null ? Number(cfg.SHIELD_DISAPPEAR_MS) : 220;
    var scaleFrom = cfg.SHIELD_APPEAR_SCALE != null ? Number(cfg.SHIELD_APPEAR_SCALE) : 1.22;
    var scaleTo = cfg.SHIELD_DISAPPEAR_SCALE != null ? Number(cfg.SHIELD_DISAPPEAR_SCALE) : 1.22;
    var steadyScale = cfg.SHIELD_FIELD_SCALE != null ? Number(cfg.SHIELD_FIELD_SCALE) : 1;
    if (!(appearMs > 0)) appearMs = 280;
    if (!(disappearMs > 0)) disappearMs = 220;
    if (!(scaleFrom > 1)) scaleFrom = 1.22;
    if (!(scaleTo > 1)) scaleTo = 1.22;
    if (!(steadyScale > 0)) steadyScale = 1;

    var t = currentTime != null && isFinite(currentTime) ? currentTime : nowMs();
    var fx = this.shieldFx;

    if (fx && fx.kind === "out") {
      var outP = (t - fx.t0) / disappearMs;
      if (outP >= 1) {
        this.shieldFx = null;
        return null;
      }
      var outEased = easeOutCubic(Math.max(0, outP));
      return {
        alpha: 1 - outEased,
        scale: steadyScale + (scaleTo - steadyScale) * outEased,
      };
    }

    if (!this.hasShield) return null;

    if (fx && fx.kind === "in") {
      var inP = (t - fx.t0) / appearMs;
      if (inP >= 1) {
        this.shieldFx = null;
        return { alpha: 1, scale: steadyScale };
      }
      var inEased = easeOutCubic(Math.max(0, inP));
      return {
        alpha: inEased,
        scale: scaleFrom + (steadyScale - scaleFrom) * inEased,
      };
    }

    return { alpha: 1, scale: steadyScale };
  }
  getHpPercentage() {
    if (this.maxHp <= 0) return 0;
    return Math.round((this.hp / this.maxHp) * 100);
  }
}
